import { render, staticRenderFns } from "./OfflineReturnRecord.vue?vue&type=template&id=f83e3fa2&scoped=true&"
import script from "./OfflineReturnRecord.vue?vue&type=script&lang=js&"
export * from "./OfflineReturnRecord.vue?vue&type=script&lang=js&"
import style0 from "./OfflineReturnRecord.vue?vue&type=style&index=0&id=f83e3fa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83e3fa2",
  null
  
)

export default component.exports